module.exports = __webpack_public_path__ + "img/top1.6b3fd5e7.png";